import firebase from 'firebase/app';
import 'firebase/messaging';
import 'firebase/firestore';
import 'firebase/auth';
import { logError } from '../utils/ApiHelper';

const config = window?.config;

const firebaseConfig = {
  apiKey: config?.FCM_apiKey,
  authDomain: config?.FCM_authDomain,
  databaseURL: config?.FCM_databaseURL,
  projectId: config?.FCM_projectId,
  storageBucket: config?.FCM_storageBucket,
  messagingSenderId: config?.FCM_messagingSenderId,
  appId: config?.FCM_appId,
  measurementId: config?.FCM_measurementId
};

const fcmVapidKey = config?.FCM_VapidKey;

// Initialize Firebase
if (!firebase.apps.length) {
  firebase.initializeApp(firebaseConfig);
}
export const messaging = firebase.messaging();
export const firestore = firebase.firestore();
export const firebaseAuth = firebase.auth;

export const getFCMToken = async (setToken: any) => {
  Notification.requestPermission().then(async permission => {
    if (permission === 'granted') {
      let currentToken = '';
      try {
        currentToken = await messaging.getToken({ vapidKey: fcmVapidKey });
        if (currentToken) {
          setToken(currentToken);
        }
      } catch (error) {
        logError(error);
      }
    }
  });
};
